<template>
  <header class="header">
    <app-ip-firewall-modal></app-ip-firewall-modal>
    <div class="ips-firewall">
      <button class="btn btn-primary btn-extra-round"
              @click="openIpsFirewall()">
        {{$t('message.overview.message.ipsFirewall')}}
      </button>
    </div>

    <button class="btn btn-primary btn-extra-round"
            slot="activator"
            @click="clearCache()">
        {{$t('message.overview.message.cleanCache')}}
    </button>

    <button class="btn btn-primary btn-extra-round"
            slot="activator"
            @click="updateLoginTypes()">
        {{$t('message.overview.message.updateLoginTypes')}}
    </button>
    <app-login-type-captive-modal :data-activator-text="$t('message.overview.message.updateLoginTypes')"
                                  data-entity="devices"></app-login-type-captive-modal>

    <app-date-range-statistic-filter data-entity="statistics"></app-date-range-statistic-filter>

    <button class="btn btn-extra-round btn-primary"
            @click="emitLoadData">{{$t('message.generics.message.fetchData')}}</button>

  </header>
</template>

<script>
    import AppLoginTypeCaptiveModal from '@views/admin/devices/components/device-modal/components/login-type-captive-modal/LoginTypeCaptiveModal'
    import AppIpFirewallModal from './ip-firewall-modal/IpFirewall'
    import AppDateRangeStatisticFilter from '@components/filters/DateRangeStatisticFilter'
    import EventBus from '@packages/event-bus/index'


    export default {
        components: {
            AppDateRangeStatisticFilter,
            AppIpFirewallModal,
            AppLoginTypeCaptiveModal
        },
        methods: {
          openIpsFirewall(){
            EventBus.$emit('EDIT_IPSFIREWALL')
          },
          async updateDevices(){
            let message = await this.$api.devices.updateDevices()
            EventBus.$emit('show-message', {
                type: 'SUCCESS',
                message: message,
                timeout: 3000,
            })
          },
          async clearCache() {
            let message = await this.$api.users.clearCache();

            EventBus.$emit('show-message', {
                type: 'SUCCESS',
                message: message.message,
                timeout: 3000,
            })
          },
          updateLoginTypes(){
            EventBus.$emit('UPDATE_LOGIN_TYPES')
          },
          emitLoadData() {
            EventBus.$emit("LOAD_DATA");
          }
        }
    }
</script>

<style lang="scss" scoped>
.header {
  height: 100%;
  /* padding: 0 26% 0 26%; */
  display: flex;
  align-items: center;
  /* justify-content: space-around; */

  button {
    margin-right: 15px;
  }
}
.dropdown {
  margin-left: 10px !important;
  margin-right: 10px !important;
}
</style>
